import { createContext, useContext } from 'react'

import { CommandBarItem, CommandBarOpenSource } from '../types'

export interface CommandBarContextValue {
  error?: Error
  isAvailable: boolean
  isOpen: boolean
  items: CommandBarItem[]
  loading: boolean
  openCommandBar: (source?: CommandBarOpenSource) => void
  closeCommandBar: () => void
  onQueryChange: (query: string) => void
  query: string
  runItem: (item: CommandBarItem, rank: number) => void
  /** Title of the open submenu, or `null` when at the top level. */
  submenuTitle: string | null
  /** Leave the current submenu, going back one level. */
  onBack: () => void
}

const noop = () => {}

export const defaultCommandBarContextValue: CommandBarContextValue = {
  isAvailable: false,
  isOpen: false,
  items: [],
  loading: false,
  openCommandBar: noop,
  closeCommandBar: noop,
  onQueryChange: noop,
  query: '',
  runItem: noop,
  submenuTitle: null,
  onBack: noop,
}

export const CommandBarContext = createContext<CommandBarContextValue>(
  defaultCommandBarContextValue
)

export const useCommandBar = () => useContext(CommandBarContext)

export interface CommandBarRegistrationContextValue {
  registerCommands: (key: string, commands?: CommandBarItem[]) => () => void
}

export const defaultCommandBarRegistrationContextValue: CommandBarRegistrationContextValue =
  {
    registerCommands: () => noop,
  }

export const CommandBarRegistrationContext =
  createContext<CommandBarRegistrationContextValue>(
    defaultCommandBarRegistrationContextValue
  )

export const useCommandBarRegistration = () =>
  useContext(CommandBarRegistrationContext)
